/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { createContext, useState, useEffect } from "react";
import baseUrl from "../Environment";

const OrderUserContext = createContext();

export const OrderUserProvider = ({ children }) => {
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(false);
let number = localStorage.getItem("phoneNumber")
  const LoadOrders = async () => {
    try {
      let data = await axios.get(  baseUrl +"orders/getcustomerswithorders").then(response => response.data)
      setCustomer(data);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if(number){
      LoadOrders();
    }
  }, [number]);
  return (
    <OrderUserContext.Provider value={{ customer, loading }}>
      {children}
    </OrderUserContext.Provider>
  );
};

export default OrderUserContext;
